/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWebAuthnRegistrationBeginResponse
 */
export interface OutputWebAuthnRegistrationBeginResponse {
    /**
     * WebAuthn PublicKeyCredentialCreationOptions
     * @type {object}
     * @memberof OutputWebAuthnRegistrationBeginResponse
     */
    publicKey?: object;
}

/**
 * Check if a given object implements the OutputWebAuthnRegistrationBeginResponse interface.
 */
export function instanceOfOutputWebAuthnRegistrationBeginResponse(value: object): boolean {
    return true;
}

export function OutputWebAuthnRegistrationBeginResponseFromJSON(json: any): OutputWebAuthnRegistrationBeginResponse {
    return OutputWebAuthnRegistrationBeginResponseFromJSONTyped(json, false);
}

export function OutputWebAuthnRegistrationBeginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWebAuthnRegistrationBeginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'publicKey': json['publicKey'] == null ? undefined : json['publicKey'],
    };
}

export function OutputWebAuthnRegistrationBeginResponseToJSON(value?: OutputWebAuthnRegistrationBeginResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'publicKey': value['publicKey'],
    };
}

